import { Component, OnDestroy, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { DataService_TopicMaintenance } from "./shared/data.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { PanicAlertTopicModifyComponent } from "./panic-alert-topic-modify/panic-alert-topic-modify.component";
import { ConfirmationService } from "primeng/api";

@Component({
	selector: "app-panic-alert-topic-maintenance",
	templateUrl: "./panic-alert-topic-maintenance.component.html",
	styleUrls: ["./panic-alert-topic-maintenance.component.css"],
})
export class PanicAlertTopicMaintenanceComponent implements OnInit, OnDestroy {
	constructor(
		private selectService: SchoolselectorService,
		private dataService: DataService_TopicMaintenance,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school);
		});
	}

	ngOnDestroy(): void {
		try {
			this.subscription.unsubscribe();
		} catch (e) {
			e.toString();
		}
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	subscription: any;
	SelectedSchool: any;

	pagerows: any = 10;
	pagefirst: any = 0;

	SelectedPortalPanicAlertTopic: any;
	lstPortalPanicAlertTopic: any = [];

	lstSchoolName: any = [];
	lstActiveDesc: any = [];

	cols: any = [
		{ field: "TopicCD", header: "Topic" },
		{ field: "TopicDesc", header: "Description" },
		{ field: "SchoolName", header: "School" },
		{ field: "ActiveDesc", header: "Active" },
		{ field: "c_dateDesc", header: "Last Updated" },
		{ field: "PersonCount", header: "# of People" },
	];

	TableLoading: boolean = false;
	Processing: boolean = false;
	errorMessage: string = "";

	ToggleText: string = "Deactivate Topic";

	ShowInfo: boolean = false;

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadPortalPanicAlertTopic() {
		this.onRowUnselect(null);

		this.TableLoading = true;

		var result = this.dataService.PanicAlertTopicSelectList(this.SelectedSchool.SchoolID);
		result.subscribe(
			(response) => {
				this.lstPortalPanicAlertTopic = response;

				//Load Data Filter Lists
				this.lstSchoolName = Array.from(new Set(this.lstPortalPanicAlertTopic.map((item: any) => item.SchoolName))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstPortalPanicAlertTopic.map((item: any) => item.ActiveDesc))).sort();

				this.TableLoading = false;
			},
			(error) => {
				this.TableLoading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadPortalPanicAlertTopic();
	}

	onAdd() {
		var ref = this.dialogService.open(PanicAlertTopicModifyComponent, {
			header: "Add Topic",
			width: "fit-content",
			data: {
				EditMode: false,
				SelectedSchool: this.SelectedSchool,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadPortalPanicAlertTopic();
			}
		});
	}
	onEdit() {
		this.errorMessage = "";

		if (this.SelectedPortalPanicAlertTopic == undefined) {
			this.errorMessage = "Select a Topic to Edit";
			return;
		}

		var ref = this.dialogService.open(PanicAlertTopicModifyComponent, {
			header: "Edit Topic",
			width: "fit-content",
			data: {
				EditMode: true,
				SelectedSchool: this.SelectedSchool,
				SelectedTopic: this.SelectedPortalPanicAlertTopic,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadPortalPanicAlertTopic();
			}
		});
	}

	onToggle() {
		this.errorMessage = "";

		if (this.SelectedPortalPanicAlertTopic == undefined) {
			this.errorMessage = "Select a Topic to Deactivate";
			return;
		}

		this.Processing = true;

		var ChangeTo = this.SelectedPortalPanicAlertTopic.Active == true ? 0 : 1;

		var result = this.dataService.PanicAlertTopicToggle(this.SelectedPortalPanicAlertTopic.PortalPanicAlertTopicID, ChangeTo);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "panicalerttopic",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Topic was " + (ChangeTo == 1 ? "activated" : "deactivated") + " successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadPortalPanicAlertTopic();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "panicalerttopic",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not " + (ChangeTo == 1 ? "Activate" : "Deactivate") + " the Topic: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onDelete() {
		this.errorMessage = "";

		if (this.SelectedPortalPanicAlertTopic == undefined) {
			this.errorMessage = "Select a Topic to Delete";
			return;
		}

		this.Processing = true;

		var result = this.dataService.PanicAlertTopicDelete(this.SelectedPortalPanicAlertTopic.PortalPanicAlertTopicID);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "panicalerttopic",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Topic was deleted successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadPortalPanicAlertTopic();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "panicalerttopic",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Delete the Topic: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onShowInfo() {
		this.ShowInfo = !this.ShowInfo;
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onSchoolChange(val) {
		this.SelectedSchool = val;

		this.loadPortalPanicAlertTopic();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";
		this.SelectedPortalPanicAlertTopic = val.data;

		this.ToggleText = "Deactivate Topic";
		if (this.SelectedPortalPanicAlertTopic.Active == false) {
			this.ToggleText = "Activate Topic";
		}
	}
	onRowUnselect(val) {
		this.errorMessage = "";
		this.SelectedPortalPanicAlertTopic = null;

		this.ToggleText = "Deactivate Topic";
	}
	onRowDblClick(PortalPanicAlertTopic) {
		this.errorMessage = "";
		this.SelectedPortalPanicAlertTopic = PortalPanicAlertTopic;
		this.onEdit();

		this.ToggleText = "Deactivate Topic";
		if (this.SelectedPortalPanicAlertTopic.Active == false) {
			this.ToggleText = "Activate Topic";
		}
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		return this.TableLoading == true || this.Processing == true;
	}

	////////////////////////////////////////////
}
